export default __webpack_public_path__ + "static/media/consorcioLogo.b9ee4537.svg";